import React, { useState } from "react";
import { useAuth } from "../../providers/AuthenticationProvider";
import Container from "@mui/material/Container";
import { Box, Stack } from "@mui/material";
import logo from "../../assets/logo.png";
import { useNavigate } from "react-router-dom";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import Button from "@mui/material/Button";
import { useSnackbar } from "../../providers/SnackbarProvider";
export const Signup = ({ isFromLanding }: { isFromLanding?: boolean }) => {
	const [email, setEmail] = useState<string>("");
	const [password, setPassword] = useState<string>("");
	const [showPassword, setShowPassword] = useState(false);
	const { signWithEmailAndPassword } = useAuth();
	const { openSnackbar } = useSnackbar();
	const navigate = useNavigate();

	const handleEmailChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		setEmail(event.target.value);
	};

	const handlePasswordChange = (
		event: React.ChangeEvent<HTMLInputElement>
	) => {
		setPassword(event.target.value);
	};

	const handleSignup = async () => {
		try {
			await signWithEmailAndPassword(email, password);
			openSnackbar("", "Registrazione avvenuta con successo", "success");
		} catch (err) {
			const error = err as Error;
			console.log(err);
			openSnackbar("", error.message, "error");
		}
	};
	const handleClickShowPassword = () => {
		setShowPassword(!showPassword);
	};

	return (
		<Container
			sx={{
				mb: isFromLanding ? 12 : 0,
			}}
		>
			<Box
				mt={isFromLanding ? 4 : 16}
				sx={{ marginBottom: 12, fontWeight: "bold" }}
			>
				<img
					src={logo}
					style={{
						width: "220px",
						display: "block",
						margin: "auto",
					}}
				/>

				<div
					style={{
						textTransform: "uppercase",
						textAlign: "center",
						margin: "10px auto",
						fontSize: "16px",
						fontFamily: "Work Sans !important",
					}}
				>
					Signup
				</div>
			</Box>

			<Stack
				spacing={2}
				sx={{ maxWidth: 440, margin: "auto", display: "block" }}
			>
				<TextField
					id="email"
					label="Email"
					color="primary"
					fullWidth
					value={email}
					onChange={handleEmailChange}
					onKeyDown={(event) => {
						if (event.key === "Enter") {
							handleSignup();
							event.preventDefault();
						}
					}}
				/>
				<TextField
					id="password"
					label="Password"
					fullWidth
					type={showPassword ? "text" : "password"}
					autoComplete="current-password"
					value={password}
					onChange={handlePasswordChange}
					InputProps={{
						endAdornment: (
							<InputAdornment position="end">
								<IconButton
									aria-label="toggle password visibility"
									onClick={handleClickShowPassword}
									edge="end"
								>
									{showPassword ? (
										<VisibilityOff />
									) : (
										<Visibility />
									)}
								</IconButton>
							</InputAdornment>
						),
					}}
					onKeyDown={(event) => {
						if (event.key === "Enter") {
							handleSignup();
							event.preventDefault();
						}
					}}
				/>
				<Button
					variant="contained"
					color="secondary"
					onClick={handleSignup}
					size="large"
					fullWidth
					sx={{
						height: "55px",
						textTransform: "none",
						fontFamily: "Work Sans !important",
					}}
					onKeyDown={(event) => {
						if (event.key === "Enter") {
							handleSignup();
							event.preventDefault();
						}
					}}
				>
					Signup
				</Button>
			</Stack>

			<Stack
				alignItems={"center"}
				sx={{
					marginTop: 2,
				}}
			>
				<Button
					variant="text"
					color="secondary"
					sx={{
						textTransform: "none",
						fontFamily: "Work Sans !important",
					}}
					onClick={() => {
						navigate("/login");
					}}
				>
					Already have an account? Login
				</Button>
			</Stack>
		</Container>
	);
};
